import React from 'react';
import {
  MemberRowMenu,
  type MemberRowMenuProps,
} from '../../shared/MemberRowMenu/MemberRowMenu';
import { MONKEY_USER_ID } from '../../../constants/monkey';
import { GROUP_ROW_MENU_REASONS } from '../../../src/friends/constants/friendInvite.constants';
import type { LeaderboardEntry } from '../../../src/worldcup/types/worldcup.types';
import type { FriendStatus } from '../../../src/friends/helpers/friendStatusMap.helper';

export interface GroupMemberRowMenuProps {
  entry: LeaderboardEntry;
  position: { top: number; right: number };
  currentUserId: string | null;
  /** When true, "Remove from squad" is enabled (admin only). */
  canRemove: boolean;
  /** Caller's friendship relationship with this entry's user. */
  friendStatus: FriendStatus;
  /** True while a friend request to this row's user is in flight. */
  isFriendRequestSending: boolean;
  /** True while any member removal mutation is in flight (blocks duplicate kicks). */
  isMemberRemovalSending: boolean;
  theme: MemberRowMenuProps['theme'];
  onClose: () => void;
  onAddFriend: (entry: LeaderboardEntry) => void;
  onRemoveMember: (entry: LeaderboardEntry) => void;
}

const isMonkey = (userId: string) => userId === MONKEY_USER_ID;

export const GroupMemberRowMenu: React.FC<GroupMemberRowMenuProps> = ({
  canRemove,
  isMemberRemovalSending,
  ...rest
}) => (
  <MemberRowMenu
    {...rest}
    canRemove={canRemove && !isMemberRemovalSending}
    removeLabel="Remove from squad"
    removeDisabledReason={
      isMemberRemovalSending
        ? GROUP_ROW_MENU_REASONS.MEMBER_REMOVAL_SENDING
        : 'Only admins can remove members'
    }
    isBotUser={isMonkey}
  />
);
